import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes';

const KakaoPayCancelPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`${ROUTES.moreMembership}?result=fail`, { replace: true });
  }, [navigate]);

  return null;
};

export default KakaoPayCancelPage;
